export enum REDUCERS {
  FAQ = 'faq',
  AUTH = 'auth',
  ROOT = 'root',
  CART = 'cart',
  HOME = 'home',
  INFO = 'info',
  STAFF = 'staff',
  PATIENTS = 'patients',
  PACKAGES = 'packages',
  PROCEDURE = 'procedure',
  PROVIDER = 'provider',
  BOOKING = 'booking',
  OPTION = 'option',
  SUPPORT = 'support',
  SETTINGS = 'settings',
  ADMIN = 'admin',
  SCHEDULE = 'schedule',
  MEDICAL_ISSUES = 'medicalIssues',
  CHIEF_COMPLAINTS = 'chiefComplaints',
  TEAM_CHAT = 'teamChat',
  JITSI_TELEHEALTH = 'jitsiTelehealth',
  SERIES = 'series',
}
